export default {"src":"/_next/static/media/ebst.53349de6.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};